import { render } from "./delete_categorie.vue?vue&type=template&id=8749eb8e&scoped=true"
import script from "./delete_categorie.vue?vue&type=script&lang=js"
export * from "./delete_categorie.vue?vue&type=script&lang=js"

import "../../assets/css/modal.css?vue&type=style&index=0&id=8749eb8e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8749eb8e"]])

export default __exports__